import React, { useCallback, useMemo } from "react";
// import Hello from './Hello';
import "./styles.css";

import { Accordion } from "semantic-ui-react";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	Stack,
	Typography,
} from "@mui/material";
import { Box } from "@mui/system";

export const ProductCategoryAccordion = ({
	categories,
	open,
	setOpen,
	setCategory,
	list = false,
}) => {
	const handleClose = () => {
		setOpen(false);
	};

	const SubAccordionContent = ({ category }) => {
		const handleChecked = () => {
			handleClose();
			setCategory(category);
		};

		return (
			<Box className="indent" sx={{ marginY: 1.5, marginX: 2 }}>
				<FormControl fullWidth>
					<Stack
						direction={"row"}
						justifyContent="space-between"
						sx={{
							border: "1px solid rgb(34 36 38 / 15%)",
							paddingX: 1,
						}}
						// marginBottom={1}
						// padding={1}
						component={"div"}
					>
						<Typography p={1} variant="h6">
							{category.name}({category.products_count || 0})
						</Typography>
						{!list && (
							<Button
								onClick={() => handleChecked(category.id)}
								variant="text"
							>
								Select
							</Button>
						)}
					</Stack>

					{/* <FormControlLabel
					sx={{ paddingX: 2 }}
					control={<Checkbox value={category.id} checked={checked}  onChange={handleChecked}/>}
					label={category.name}
				/> */}
				</FormControl>
			</Box>
		);
	};

	// const setCategoryList = (category) => {
	// 	// const [categoryid, setCategoryId] = useState("");
	// 	let sub_menu = category.sub_category.map((sub) => {
	// 		let co = setCategoryList(sub);
	// 		// console.log(co);
	// 		return co;
	// 	});

	// 	const AccordionPanels = {
	// 		title: `${category.name}(${category.products_count || 0})`,
	// 		key: "testing-key-" + category.id,
	// 		content: {
	// 			content: (
	// 				<SubAccordionContent
	// 					category={category}
	// 					sub_menu={sub_menu}
	// 				/>
	// 			),
	// 			key: "sub-" + category.id + "accordions",
	// 		},
	// 	};
	// 	return AccordionPanels;
	// };

	const sortCategories = useCallback((cats = []) => {
		return cats
			.map((cat) => ({
				...cat,
				sub_category: sortCategories(cat.sub_category || []),
			}))
			.sort((a, b) => {
				const aHasChildren = a.sub_category?.length > 0 ? 1 : 0;
				const bHasChildren = b.sub_category?.length > 0 ? 1 : 0;

				// Categories WITH subcategories first
				return bHasChildren - aHasChildren;
			});
	}, []);

	const accord = useMemo(() => {
		const buildPanel = (category) => {
			const children = category.sub_category || [];
			const hasChildren = children.length > 0;

			const title = `${category.name} (${category.products_count || 0})`;

			if (!hasChildren) {
				return {
					title,
					key: `key-${category.id}`,
					content: {
						content: <SubAccordionContent category={category} />,
					},
				};
			}

			const nested = [];
			const leaves = [];

			children.forEach((sub) => {
				if (sub.sub_category?.length) {nested.push(sub);}
				else {leaves.push(sub);}
			});

			return {
				title,
				key: `key-${category.id}`,
				content: {
					content: (
						<>
							{nested.length > 0 && (
								<Accordion.Accordion
									exclusive={false}
									panels={nested.map(buildPanel)}
									// exclusive={false}
									style={{ marginLeft: "20px" }}
									className="no-padding"
								/>
							)}

							{leaves.map((leaf) => (
								<SubAccordionContent
									key={`testing-key-${leaf.id}`}
									category={leaf}
								/>
							))}
						</>
					),
				},
			};
		};

		return sortCategories(categories).map(buildPanel);
	}, [categories, sortCategories]);
	return (
		<Dialog
			fullWidth={true}
			maxWidth={"md"}
			open={open}
			onClose={handleClose}
		>
			<DialogTitle>Product Categories</DialogTitle>
			<DialogContent>
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						m: "auto",
						width: "fit-content",
					}}
				>
					<Accordion panels={accord} styled />
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} variant="contained">
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};
